import * as React from 'react';
import MemberConnectContainer from 'containers/member/MemberConnectContainer';

const MemberConnect = () => {
  return <MemberConnectContainer />;
};

export default MemberConnect;
